export const SEGMENT_CATEGORY_REPORT_ID = 'segment-category';
